<div class="flex flex-col py-4">
  <div>
    <div class="flex items-center justify-between">
      <div class="text-xl font-medium">Parking</div>
      <button matIconButton (click)="sheetComponentRef.onDismiss.next(poiActionsEnum.DISMISS)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <hr class="mt-3 mb-5" />
    <div class="flex flex-col par-font-small mb-8 leading-normal whitespace-pre-wrap gap-6">
      <app-reviews-votes-summary
        [positiveCount]="data.parkingPoint.likeCount"
        [negativeCount]="data.parkingPoint.dislikeCount"
      />

      <div class="flex gap-1">
        <mat-icon>location_on</mat-icon>
        <div class="w-fit pt-[2px]">
          {{ data.parkingPoint.address || 'Brak informacji o adresie' }}
        </div>
      </div>
    </div>
  </div>

  <div class="relative -translate-x-1/2 left-1/2 w-dvw pb-2 overflow-auto">
    <div class="flex flex-row gap-2 px-4 flex-nowrap w-fit">
      @for (menu of menuItems; track menu) {
        @if (menu.isPrimary) {
          <button
            mat-flat-button
            class="flex justify-center!"
            (click)="choose(menu.result)"
            [appGuideStep]="getGuideStep(menu.result)"
          >
            @if (menu.icon) {
              <mat-icon>{{ menu.icon }}</mat-icon>
            }
            <div>{{ menu.label }}</div>
          </button>
        } @else {
          <button
            mat-stroked-button
            class="flex justify-center! items-center!"
            (click)="choose(menu.result)"
            [appGuideStep]="getGuideStep(menu.result)"
          >
            @if (menu.icon) {
              <mat-icon>{{ menu.icon }}</mat-icon>
            }
            <div>{{ menu.label }}</div>
          </button>
        }
      }
    </div>
  </div>
</div>
